<template>
    <div class="w100 pl20 pr20 pt20 pb20" v-loading="loading">
        <div class="search-warp">

            <el-form label-width="120px" class="demo-form-inline">
                <el-col :span="8">
                <el-form-item label="部门名称" prop="respDeptId">

                    <TreeSelect size="small"
                                :data="departmentData"
                                clearable
                                expandAll
                                ref="deptSingle"
                                :obj="mapKey"
                                checkStrictly
                                @getValue="setDeptSingleMenu">
                    </TreeSelect>
                </el-form-item>
                </el-col>
                <el-col  :span="8">
                    <el-form-item label="服务名称" prop="respDeptId" style="min-width: 250px;">
                        <div class="el-select-serve" @click="serveSelect()">
                            <el-tag
                                    :key="tag.serve_id"
                                    v-for="tag in serveList"
                                    closable
                                    style="margin:0 3px"
                                    :disable-transitions="false"
                                    @close="handleClose(tag)">
                                {{tag.server_name}}
                            </el-tag>

                        </div>
                    </el-form-item>
                </el-col>

            <el-col :span="4">
                <el-button type="primary" @click="initPage">查询</el-button>
                <el-button type="primary" @click="addFn">添加</el-button>
            </el-col>
            </el-form>
        </div>

        <div class="table-con">
            <el-table class="w100 mt20 table" header-row-class-name="table-head"
                      row-class-name="cu-p" stripe :data="list">
                <el-table-column align="center" label="序号" width="50px">
                    <template slot-scope="scope">
                        {{ paramSearch.current * paramSearch.size - paramSearch.size + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="resp_dept_name" label="部门名称"></el-table-column>
                <el-table-column align="center" prop="gcRole"   label="岗位名称">
                    <!--<template slot-scope="scope">-->
                        <!--<el-tag type="success"  v-show="item"  v-for="item in mapToArr(scope.row.gcRole)">{{item}}</el-tag>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column align="center" prop="rights" label="权利说明">
                    <template slot-scope="scope">
                       <div v-html="scope.row.rights"></div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="responseblity" label="责任说明">
                    <template slot-scope="scope">
                        <div v-html="scope.row.responseblity"></div>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="gcServe"  label="服务内容">
                    <!--<template slot-scope="scope">-->
                        <!--<el-tag v-show="item" v-for="item in mapToArr(scope.row.gcServe)">{{item}}</el-tag>-->
                    <!--</template>-->
                </el-table-column>
                <!--<el-table-column align="center" prop="timeLimitType" label="办理时效"></el-table-column>-->
                <el-table-column align="center" prop="refuseIP" label="操作">
                    <template slot-scope="scope">
                        <div class="to-use">
                            <span class="info" @click="editFn(scope.row.id)">编辑</span>
                            <span class="danger" @click="deleteFn(scope.row.id)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="mt20 flex-box">
            <div class="flex-1"></div>
            <el-pagination background @size-change="changeSize"
                           @current-change="changePage"
                           :current-page="paramSearch.current"
                           :page-sizes="pageSizes"
                           :page-size="paramSearch.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total"
            ></el-pagination>
        </div>

        <!-- 详情、新增 -->
        <RightsliDialog ref="SpecialDialog" @saveSuccess="saveSuccess"/>
        <select-serve ref="selectServeRef" @sureSelect="sureSelect"/>
    </div>
</template>

<script>
    import SelectServe from "@/components/SelectServe.vue";
    import TreeSelect from "@/components/TreeSelect.vue";
    import RightsliDialog from "@/components/management/rightsli/RightsliDialog";
    import { getDutyList,getDutyInfo, handleDutyDelete} from '@/api/managementCenter/chargeManage';
    import { getDeptTree} from '@/api/managementCenter/otherApi';

    export default {
        name: "Rightsli",
        components: {
            SelectServe,
            TreeSelect,
            RightsliDialog
        },
        props: [],
        data() {
            return {
                loading: false,
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    serveIds:[],
                    respDeptId:""
                },
                total: 0,
                mapKey:{
                    id:'id',// ID
                    label: 'name',// 显示名称
                    children: 'children', //子级字段名
                },
                departmentData:[],
                serveList:[]
            };
        },
        mounted() {
            this.getListFn();
            this.getDeptTreeData();
        },
        methods: {

            mapToArr(strs){
                let str = strs || ''
                return str.split(",")
            },
            setDeptSingleMenu(key,data){//获取子组件值
                this.paramSearch.respDeptId = data.id;
            },
            getDeptTreeData(){
                getDeptTree().then(({data})=>{
                    if(data.code == 0){
                        this.departmentData = data.data
                    }
                }).catch(err=>{

                })

            },


            // 获取查询列表
            getListFn () {
                this.loading = true;
                this.paramSearch.serveIds = this.serveList.map(item=>{
                    return item.serve_id
                }).join(',')
                getDutyList(this.paramSearch).then(({data})=> {
                    this.loading = false;
                    if(data.code == 0){
                        this.list = data.data.records || []
                        this.total = data.data.total;
                    }
                })
                    .catch(() => {
                        this.loading = false;
                    });
            },

            // 添加
            addFn() {
                this.$refs.SpecialDialog.dialogShow('add');
            },

            // 删除
            deleteFn (id, name) {
                this.$confirm( "是否确定删除?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteHttp(id)

                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            deleteHttp(id){
                this.loading = true;
                // 删除接口
                handleDutyDelete(id).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success("删除成功!" );
                        this.getListFn();
                    }else{
                        this.$message.warning(data.msg|| "删除失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "删除异常!" );
                });
            },
            // 详情
            editFn (id) {
                this.loading = true;
                getDutyInfo(id).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0){

                        this.$refs.SpecialDialog.dialogShow('edit',data.data);

                    }else{
                        this.$message.warning( data.msg||"获取权责信息失败！" );
                    }
                }).catch(err=>{
                    this.loading = false;
                })


            },

            // 默认页面数据
            initPage() {
                this.paramSearch={
                    ...this.paramSearch,
                    current:1
                }
                this.getListFn();
            },

            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            saveSuccess(){
                this.getListFn();
            },
            sureSelect(data){
                this.serveList = data
            },

            serveSelect(){
                this.$refs.selectServeRef.openDialog(this.serveList)
            },
            handleClose(tag){
                this.serveList =this.serveList.filter(item=>{
                    return item.serve_id!=tag.serve_id
                })
            },
        },
        watch: {},
        filters: {}
    };
</script>

<style scoped lang="less">

    @import "../../../assets/css/handleBtn.less";
    .search-warp{
        height:40px ;
    }
    .el-select-serve{
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        height: 32px;
        padding: 0px 8px;
        cursor: pointer;
        max-height: 200px;
        overflow: auto;
        margin-right: 10px;
    }
    /deep/.el-table {
        width: 100%;
        .el-table__body-wrapper {
            max-height: calc(100vh - 300px);
            overflow-y: auto;

        }
    }
</style>
